import http from '@core/fetch'

export default {
  withdraw_statistics_v2: () =>
    http('/p/wedding/Shopadmin/APIShopWallet/withdraw_statistics_v2'),

  pay: body => http.post('/p/wedding/Admin/APIMerchantWeapp/pay', { body }),

  reg_pay: body =>
    http.post('/p/wedding/Admin/APIMerchantWeapp/reg_pay', { body }),

  check_pay: () => http('/p/wedding/Admin/APIMerchantWeapp')
}
